<template>
  <div class="column full-height full-width">
    <div class="col">
      <q-splitter
        horizontal
        v-model="splitterModel"
        style="height: 100%"
        ref="attendance"
        :limits="[0, 100]"
        :disable="!hasProfiler || profilerMinimized"
        :separator-class="hasProfiler && !profilerMinimized ? '' : 'tw-hidden'"
      >
        <template #before>
          <slot name="before" />
        </template>

        <template #separator>
          <DragHorizontalIcon v-if="hasProfiler" />
        </template>

        <template #after>
          <div
            v-if="isEmail ? hasProfiler : true"
            v-show="isEmail ? true : hasProfiler"
            class="full-height full-width"
          >
            <slot name="after" />
          </div>
        </template>
      </q-splitter>
    </div>
  </div>
</template>

<script>
import DragHorizontalIcon from '@/assets/icons/DragHorizontalIcon.svg'

export default {
  components: {
    DragHorizontalIcon
  },

  props: {
    hasProfiler: {},
    isEmail: {},
    profilerMinimized: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      splitterModel: !this.hasProfiler ? 100 : (this.profilerMinimized ? 93 : 50),
      containerHeight: 0
    }
  },

  mounted () {
    this.updateContainerHeight()
    window.addEventListener('resize', this.updateContainerHeight)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.updateContainerHeight)
  },

  computed: {
    minimizedModel () {
      if (!this.containerHeight) return 93
      const pct = 100 - (40 / this.containerHeight * 100)
      return Math.min(pct, 99)
    }
  },

  methods: {
    updateContainerHeight () {
      this.$nextTick(() => {
        this.containerHeight = this.$el?.clientHeight || 0
        if (this.profilerMinimized && this.hasProfiler) {
          this.splitterModel = this.minimizedModel
        }
      })
    }
  },

  watch: {
    hasProfiler (val) {
      if (!val) {
        this.splitterModel = 100
        return
      }
      this.splitterModel = this.profilerMinimized ? this.minimizedModel : 50
    },
    profilerMinimized (val) {
      if (!this.hasProfiler) return
      this.splitterModel = val ? this.minimizedModel : 50
    },
    splitterModel: {
      deep: true,
      handler (newValue, oldValue) {
        const nv = newValue ? newValue.toFixed(1) : '0'
        const ov = oldValue ? oldValue.toFixed(1) : '0'
        if (nv === ov) return

        const areas = this.$refs?.attendance?.$children
        if (!areas?.length) return
        if (areas[0]?.recalcArea) areas[0].recalcArea()
      }
    }
  }
}
</script>
